module.exports = __webpack_public_path__ + "img/hkis2.ff306243.png";